import script from "./SelectParticipants.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectParticipants.vue?vue&type=script&setup=true&lang=js"

import "./SelectParticipants.vue?vue&type=style&index=0&id=4890fae3&scoped=true&lang=css"

import exportComponent from "F:\\kobutsu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4890fae3"]])

export default __exports__